/**
 * Format sort keys to camel case in sort list component
 *
 * @param {string} key
 * @returns {*}
 */
const formatKey2CamelCase = (key) => key.split('_').join('-');

export default formatKey2CamelCase;
